import { render, staticRenderFns } from "./DivideUnstressedVowelsForm.vue?vue&type=template&id=ca9d0f3c&scoped=true&lang=pug&"
import script from "./DivideUnstressedVowelsForm.vue?vue&type=script&lang=js&"
export * from "./DivideUnstressedVowelsForm.vue?vue&type=script&lang=js&"
import style0 from "./DivideUnstressedVowelsForm.vue?vue&type=style&index=0&id=ca9d0f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9d0f3c",
  null
  
)

export default component.exports